import React from "react";

export default function AMAForm({
  formData,
  onChange,
  isViewOnly,
  editingFormId,
  shouldDisableField,
  getFieldStyle
}) {
  const handleChange = (field, value) => {
    onChange(field, value);
  };

  // Helper inside if not provided or to ensure it works
  const isDisabled = (fieldName, fieldValue) => {
    if (shouldDisableField) return shouldDisableField("ama", fieldName, fieldValue);
    if (isViewOnly) return true;
    const patientInfoFields = ["patientName", "fileNo", "date", "cprNo", "physician", "ageSex"];
    return patientInfoFields.includes(fieldName);
  };

  const getStyle = (fieldName, fieldValue) => {
    if (getFieldStyle) return getFieldStyle("ama", fieldName, fieldValue);
    if (isDisabled(fieldName, fieldValue) && !isViewOnly) {
      return { backgroundColor: "#e9ecef", cursor: "not-allowed" };
    }
    return {};
  };

  return (
    <div className="row g-2 amaForm">
      <style>{`
        .amaForm .form-control,
        .amaForm .form-select {
          font-size: 12px;
          height: 32px;
          padding: 4px 10px;
        }
        .amaForm textarea.form-control {
          height: auto;
        }
      `}</style>

      {/* Patient Information */}
      <div className="col-12 mt-1">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Patient Information</h6>
      </div>
      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Patient's Name</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.patientName}
          onChange={(e) => handleChange("patientName", e.target.value)}
          disabled={isDisabled("patientName", formData.patientName)}
          style={getStyle("patientName", formData.patientName)}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>File No</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.fileNo}
          onChange={(e) => handleChange("fileNo", e.target.value)}
          disabled={isDisabled("fileNo", formData.fileNo)}
          style={getStyle("fileNo", formData.fileNo)}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Date</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={formData.date}
          onChange={(e) => handleChange("date", e.target.value)}
          disabled={isDisabled("date", formData.date)}
          style={getStyle("date", formData.date)}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>CPR No</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.cprNo}
          onChange={(e) => handleChange("cprNo", e.target.value)}
          disabled={isDisabled("cprNo", formData.cprNo)}
          style={getStyle("cprNo", formData.cprNo)}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Physician</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.physician}
          onChange={(e) => handleChange("physician", e.target.value)}
          disabled={isDisabled("physician", formData.physician)}
          style={getStyle("physician", formData.physician)}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Age/Sex</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.ageSex}
          onChange={(e) => handleChange("ageSex", e.target.value)}
          disabled={isDisabled("ageSex", formData.ageSex)}
          style={getStyle("ageSex", formData.ageSex)}
        />
      </div>

      {/* Recommendation */}
      <div className="col-12 mt-2">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Recommendation</h6>
      </div>
      <div className="col-12">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Physical Recommendation</label>
        <textarea
          className="form-control form-control-sm"
          rows="3"
          value={formData.recommendation}
          onChange={(e) => handleChange("recommendation", e.target.value)}
          disabled={isDisabled("recommendation", formData.recommendation)}
          style={getStyle("recommendation", formData.recommendation)}
        ></textarea>
      </div>

      {/* Signatures */}
      <div className="col-12 mt-2">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Signatures</h6>
      </div>
      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Patient's Name & Signature</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.patientSignature}
          onChange={(e) => handleChange("patientSignature", e.target.value)}
          disabled={isDisabled("patientSignature", formData.patientSignature)}
          style={getStyle("patientSignature", formData.patientSignature)}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Date</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={formData.patientSignatureDate}
          onChange={(e) => handleChange("patientSignatureDate", e.target.value)}
          disabled={isDisabled("patientSignatureDate", formData.patientSignatureDate)}
          style={getStyle("patientSignatureDate", formData.patientSignatureDate)}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Witness's Name & Signature</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.witnessSignature}
          onChange={(e) => handleChange("witnessSignature", e.target.value)}
          disabled={isDisabled("witnessSignature", formData.witnessSignature)}
          style={getStyle("witnessSignature", formData.witnessSignature)}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Date</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={formData.witnessSignatureDate}
          onChange={(e) => handleChange("witnessSignatureDate", e.target.value)}
          disabled={isDisabled("witnessSignatureDate", formData.witnessSignatureDate)}
          style={getStyle("witnessSignatureDate", formData.witnessSignatureDate)}
        />
      </div>
    </div>
  );
}
